import Vue from 'vue';
import Vuex from 'vuex';
import app from './app';
import user from './user';
import courses from './courses';

Vue.use(Vuex);

export default new Vuex.Store({
  // Dev only: strict mode deep-traverses the whole state on every write (EG-23610).
  strict: process.env.NODE_ENV !== 'production',
  modules: { app, user, courses }
});
